import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Time: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.161 15.8538C20.2828 15.5595 20.6281 15.4173 20.929 15.537C21.2308 15.6558 21.3766 15.9925 21.2539 16.2859C20.581 17.9054 19.4863 19.3168 18.1046 20.3872C16.745 21.4404 15.103 22.1669 13.3057 22.4424C12.9845 22.491 12.6836 22.2758 12.6347 21.9635C12.5849 21.6502 12.8055 21.3567 13.1257 21.309C14.7115 21.066 16.1642 20.4223 17.3707 19.4871C18.5946 18.5383 19.5647 17.2879 20.161 15.8538ZM11.1026 6.26951C11.1026 5.95174 11.3675 5.69339 11.6933 5.69339C12.0191 5.69339 12.284 5.95174 12.284 6.26951V12.5087C12.284 12.7373 12.1474 12.9354 11.9489 13.0281L7.88947 15.3137C7.60795 15.473 7.24704 15.3794 7.08461 15.1039C6.92124 14.8294 7.01723 14.4774 7.29968 14.319L11.1035 12.1774V6.26848L11.1026 6.26951ZM18.9694 10.972C18.7377 10.7497 18.734 10.386 18.962 10.1592C19.19 9.93323 19.5629 9.92963 19.7955 10.152L20.6973 11.0144C20.3751 9.15277 19.4613 7.48827 18.1508 6.20997C16.4986 4.59863 14.2151 3.6013 11.6934 3.6013C9.43017 3.6013 7.35981 4.40247 5.76579 5.72935C4.1459 7.07874 3.01512 8.9683 2.6699 11.1099C2.62006 11.4231 2.32007 11.6374 1.99888 11.5887C1.67767 11.5401 1.45799 11.2476 1.50785 10.9343C1.89827 8.51185 3.17389 6.37675 5.00047 4.85625C6.80311 3.35564 9.14099 2.44922 11.6932 2.44922C14.5407 2.44922 17.1196 3.57535 18.9858 5.3955C20.4442 6.8178 21.4678 8.66325 21.8461 10.7274L22.4064 9.83889C22.5772 9.56792 22.9408 9.4833 23.2187 9.64985C23.4965 9.81639 23.5832 10.1711 23.4125 10.442L21.9311 12.7905C21.8295 12.9651 21.6375 13.0831 21.4169 13.0831C21.2397 13.0831 21.081 13.0075 20.973 12.8868L18.9709 10.9703L18.9694 10.972ZM10.2599 21.3088C10.5812 21.3574 10.8008 21.65 10.751 21.9632C10.7011 22.2765 10.4011 22.4907 10.08 22.4421C9.71075 22.3854 9.35816 22.3125 9.02402 22.2261C8.67419 22.1351 8.33176 22.0262 7.99948 21.902C7.69488 21.7895 7.54167 21.4564 7.65797 21.1593C7.77335 20.8623 8.11487 20.7128 8.41947 20.8263C8.71668 20.937 9.02036 21.0342 9.32865 21.1143C9.64338 21.1963 9.95534 21.262 10.2599 21.3088ZM5.94385 19.4319C6.19583 19.6317 6.2346 19.9936 6.02969 20.2394C5.82478 20.4851 5.45373 20.5229 5.20175 20.3231C4.92299 20.1025 4.65624 19.8676 4.40242 19.6209L4.40057 19.6191C4.14859 19.3725 3.90769 19.1123 3.68154 18.8405C3.47663 18.5947 3.51448 18.2329 3.76738 18.033C4.01936 17.8332 4.39041 17.8701 4.59532 18.1167C4.79562 18.358 5.00883 18.5884 5.23404 18.809C5.46018 19.0286 5.69738 19.2375 5.94476 19.4328L5.94385 19.4319ZM3.16199 15.7023C3.27737 15.9976 3.12599 16.3298 2.82232 16.4423C2.51959 16.5548 2.17897 16.4072 2.06362 16.111C1.93347 15.7797 1.8218 15.4458 1.72948 15.1118C1.63902 14.7859 1.56518 14.4412 1.50703 14.0811C1.45719 13.7678 1.67779 13.4744 1.99807 13.4267C2.31928 13.378 2.62017 13.5932 2.66909 13.9055C2.71708 14.2035 2.78446 14.5078 2.86846 14.8147C2.95245 15.1253 3.05121 15.4206 3.16106 15.7014L3.16199 15.7023Z'
        fill='url(#paint0_linear_12280_28740)'
        stroke='url(#paint1_linear_12280_28740)'
        strokeWidth='0.7'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_28740'
          x1='6.05569'
          y1='3.813'
          x2='14.6382'
          y2='22.7349'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28740'
          x1='6.05569'
          y1='3.813'
          x2='14.6382'
          y2='22.7349'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Time;
